<template>
	<app-page>
		<app-heading :title="notification.title" />
		<app-section>
			<app-button
				:to="{ name: 'my-notifications' }"
				color="secondary"
				small
				outlined
				icon="fa-chevron-left"
				class="mb-4"
			>Back</app-button>
			<app-row>
				<app-cell><h2>{{notification.subject}}</h2></app-cell>
			</app-row>
			<app-divider class="mt-2 mb-2" />
			<app-row>
				<app-cell v-html="notification.html"></app-cell>
			</app-row>
		</app-section>
	</app-page>
</template>

<script>
export default {
	computed: {
		id() {
			return this.$route.params.notification
		},
	},
	data() {
		return {
			notification: {
				title: '',
				subject: '',
				html: '',
			},
			socket: null,
		}
	},
	mounted() {
		this.socket = this.$ravello.socket('notifications')
		this.fetchNotification()
	},
	watch: {
		$route: {
			handler() {
				this.fetchNotification()
			},
		},
	},
	methods: {
		async fetchNotification() {
			this.notification = await this.$ravello.request().me()
				.to('notifications')
				.to(this.id)
				.get()
			this.read()
		},
		async read() {
			if (this.notification && !this.notification.read) {
				await this.$ravello.request().me()
					.to('notifications')
					.to(this.id)
					.to('read')
					.create()

				this.socket.emit('read', this.id)
			}
		},
	},
	beforeDestroy() {
		if (this.socket) {
			this.socket.disconnect()
		}
	},
}
</script>
